@if (shouldDisplay()) {
  <fd-toolbar
    class="breadcrumbs indent-logo"
    [fdType]="'transparent'"
    [clearBorder]="true"
  >
    @for (breadcrumb of breadcrumbs$ | async; track breadcrumb) {
      <div class="breadcrumb-container">
        @if (!breadcrumb.type) {
          <div class="breadcrumb-logo"></div>
        }
        <div class="breadcrumb-link-container">
          @if (!!breadcrumb.type) {
            <app-icon
              class="custom-dropdown-icon"
              [icon]="breadcrumb.type | resourceGlyph"
              size="lg"
            ></app-icon>
          }
          @if (!breadcrumb.url) {
            <span class="breadcrumb-title" fd-title [title]="breadcrumb.text">{{
              breadcrumb.text
            }}</span>
          }
          @if (!!breadcrumb.url) {
            <a
              (click)="breadcrumbNavigate(breadcrumb)"
              [title]="breadcrumb.text"
              class="breadcrumb-title"
              fd-link
              [href]="breadcrumb.url"
              >{{ breadcrumb.text }}</a
            >
          }
          <fd-popover
            [(isOpen)]="breadcrumb.isOpen"
            class="breadcrumbs"
            placement="bottom"
            (isOpenChange)="onOpenChange($event, breadcrumb)"
            [noArrow]="false"
            [focusTrapped]="true"
            [focusAutoCapture]="true"
            [closeOnOutsideClick]="true"
          >
            <fd-popover-control>
              @if (!!breadcrumb.type) {
                <button
                  fd-button
                  class="open-breadcrumbs-button custom-dropdown-icon"
                  i18n-title="
                    XTOL|Tooltip of the breadcrumbs
                    button@@breadcrumbs.tooltips.dropdownButton"
                  title="Go to other folders or resource groups on this level"
                  [fdCompact]="true"
                  [fdType]="'transparent'"
                >
                  <app-icon icon="angle-down" size="lg"></app-icon>
                </button>
              }
            </fd-popover-control>
            <fd-popover-body>
              @if (breadcrumb.isOpen) {
                <div class="breadcrumbs-dropdown-body">
                  @if (breadcrumb.totalCount > SHOW_SEARCH_THRESHOLD) {
                    <div class="search-wrap">
                      <app-search-field
                        class="filter-search"
                        id="filter-search"
                        width="100%"
                        [disabled]="breadcrumb.loading"
                        [searchTerm]="searchTerm"
                        [isLiveSearch]="!isPaginatedView"
                        (doSearch)="doSearch($event, breadcrumb)"
                      ></app-search-field>
                    </div>
                  }
                  <fd-busy-indicator
                    [block]="true"
                    size="m"
                    [loading]="breadcrumb.loading"
                    ariaLabel="loading"
                  >
                    <ul fd-list class="breadcrumb-menu">
                      @if (breadcrumb.type === ResourceType.ORGANIZATION) {
                        @for (
                          item of isPaginatedView
                            ? getSiblings(breadcrumb)
                            : (getSiblings(breadcrumb)
                              | filterBy: searchTerm : ["displayName", "name"]);
                          track item
                        ) {
                          <li fd-list-item class="breadcrumb-dropdown-link">
                            <a
                              fd-list-link
                              [routerLink]="getRouterLink(item, breadcrumb)"
                              [queryParams]="{ path: '' }"
                            >
                              <app-icon
                                class="custom-dropdown-icon"
                                [icon]="item.type | resourceGlyph"
                                [fixedWidth]="true"
                              ></app-icon>
                              <span class="resource-name">{{
                                item.displayName
                              }}</span>
                            </a>
                          </li>
                        }
                        @if (!!breadcrumb.continueToken) {
                          <li
                            fd-list-item
                            [action]="true"
                            [growing]="true"
                            (click)="loadMoreLazy(breadcrumb)"
                            (keyup.enter)="loadMoreLazy(breadcrumb)"
                            (keydown.space)="$event.preventDefault()"
                            (keyup.space)="loadMoreLazy(breadcrumb)"
                          >
                            <span fd-list-title>
                              <span fd-list-title-text> Show More </span>
                            </span>
                          </li>
                        }
                        @if (
                          (isPaginatedView
                            ? getSiblings(breadcrumb)
                            : (getSiblings(breadcrumb)
                              | filterBy: searchTerm : ["displayName", "name"])
                          ).length === 0 && !!searchTerm
                        ) {
                          <li fd-list-item [noData]="true" class="no-data">
                            @if (!breadcrumb.loading) {
                              <span class="no-data-container"
                                >No results for '<span class="search-str">{{
                                  searchTerm
                                }}</span
                                >'</span
                              >
                            }
                          </li>
                        }
                        @if (
                          !breadcrumb.loading &&
                          getSiblings(breadcrumb).length === 0 &&
                          !searchTerm
                        ) {
                          <li fd-list-item [noData]="true" class="no-data">
                            @if (!breadcrumb.loading) {
                              <span class="no-data-container"
                                >There are no additional folders or resource
                                groups on this level</span
                              >
                            }
                          </li>
                        }
                      } @else {
                        @for (
                          item of getSiblings(breadcrumb)
                            | sortBy: true : "displayName" : sortFn
                            | sortByFixed: true : fixedType
                            | filterBy: searchTerm : ["displayName", "name"]
                            | slice: 0 : currentAmount;
                          track item
                        ) {
                          <li fd-list-item class="breadcrumb-dropdown-link">
                            <a
                              fd-list-link
                              [routerLink]="getRouterLink(item, breadcrumb)"
                              [queryParams]="{
                                      path:
                                        getPath(item.path) + '/' + item.name
                                    }"
                            >
                              <app-icon
                                class="custom-dropdown-icon"
                                [icon]="item.type | resourceGlyph"
                                [fixedWidth]="true"
                              ></app-icon>
                              <span class="resource-name">{{
                                item.displayName
                              }}</span>
                            </a>
                          </li>
                        }
                        @if (
                          (
                            getSiblings(breadcrumb)
                            | filterBy: searchTerm : ["displayName", "name"]
                          ).length >= currentAmount
                        ) {
                          <li
                            fd-list-item
                            [action]="true"
                            [growing]="true"
                            (click)="loadMore()"
                            (keyup.enter)="loadMore()"
                            (keydown.space)="$event.preventDefault()"
                            (keyup.space)="loadMore()"
                          >
                            <span fd-list-title>
                              <span fd-list-title-text> Show More </span>
                            </span>
                          </li>
                        }
                        @if (
                          (
                            getSiblings(breadcrumb)
                            | filterBy: searchTerm : ["displayName", "name"]
                          ).length === 0 && !!searchTerm
                        ) {
                          <li fd-list-item [noData]="true" class="no-data">
                            @if (!breadcrumb.loading) {
                              <span class="no-data-container"
                                >No results for '<span class="search-str">{{
                                  searchTerm
                                }}</span
                                >'</span
                              >
                            }
                          </li>
                        }
                        @if (
                          !breadcrumb.loading &&
                          getSiblings(breadcrumb).length === 0 &&
                          !searchTerm
                        ) {
                          <li fd-list-item [noData]="true" class="no-data">
                            @if (!breadcrumb.loading) {
                              <span class="no-data-container"
                                >There are no additional folders or resource
                                groups on this level</span
                              >
                            }
                          </li>
                        }
                      }
                    </ul>
                  </fd-busy-indicator>
                </div>
              }
            </fd-popover-body>
          </fd-popover>
          @if (!!breadcrumb.url) {
            <span style="margin-left: 10px; font-size: 1.2rem">/</span>
          }
        </div>
      </div>
    }
  </fd-toolbar>
}
